export function EditMessageIcon() {
  return (
    <svg
      width='21'
      height='20'
      viewBox='0 0 21 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        opacity='0.4'
        d='M14.666 7.49935C14.666 10.7243 11.866 13.3327 8.41602 13.3327L7.64102 14.266L7.18269 14.816C6.79102 15.2827 6.04101 15.1827 5.78268 14.6243L4.66602 12.166C3.14935 11.0993 2.16602 9.40768 2.16602 7.49935C2.16602 4.27435 4.96602 1.66602 8.41602 1.66602C10.9327 1.66602 13.1077 3.05769 14.0827 5.05769C14.4577 5.79936 14.666 6.62435 14.666 7.49935Z'
        fill='currentColor'
      />
      <path
        d='M18.8342 10.7169C18.8342 12.6252 17.8509 14.3169 16.3342 15.3836L15.2176 17.8419C14.9592 18.4002 14.2092 18.5086 13.8176 18.0336L12.5842 16.5502C10.5676 16.5502 8.76758 15.6586 7.64258 14.2669L8.41757 13.3336C11.8676 13.3336 14.6676 10.7253 14.6676 7.50025C14.6676 6.62525 14.4592 5.80026 14.0842 5.05859C16.8092 5.68359 18.8342 7.98358 18.8342 10.7169Z'
        fill='currentColor'
      />
      <path
        d='M10.5007 8.125H6.33398C5.99232 8.125 5.70898 7.84167 5.70898 7.5C5.70898 7.15833 5.99232 6.875 6.33398 6.875H10.5007C10.8423 6.875 11.1257 7.15833 11.1257 7.5C11.1257 7.84167 10.8423 8.125 10.5007 8.125Z'
        fill='currentColor'
      />
    </svg>
  );
}
